import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {DisplaySmallTypography} from 'patient-ping-remedy/packages/typography';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: ${sizes.small};
  padding: ${sizes.small} ${sizes.medium};
  border: 1px solid ${colors.gray3};
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.small};
  min-height: ${sizes.large};
  min-width: 0;
  white-space: nowrap;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xSmall};
  grid-column: 1 / 4;
`;

export const ClientName = styled(DisplaySmallTypography)<{ isCompleted: boolean }>`
  color: ${colors.primary1};
  min-width: 10rem;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isCompleted }) => isCompleted && css`
    text-decoration: line-through;
  `}
`;

export const PhoneNumber = styled.div<{ isCompleted: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: -0.4rem;
  color: ${colors.gray4};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ isCompleted }) => isCompleted && css`
    text-decoration: line-through;
  `}
`;

export const GroupAssociation = styled.div`
  color: ${colors.gray4};
`;

export const Body = styled.div`
  color: ${colors.gray4};

  &:empty {
    display: none;
  }
`;

export const TimeSince = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xxSmall};
  color: ${colors.gray4};
`;

export const TimeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${sizes.small};
`;

export const ViewConversationLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${colors.primary1};
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;

  &:hover {
    text-decoration: none;
  }
`;
